@if (loan()) {
  <div class="item">
    <div>Låntagare</div>
    <div style="max-width: 300px;">{{ loan()!.owner.name }} ({{ loan()!.owner.idNumber }})</div>
  </div>

  <form [formGroup]="form()" class="form">

    <mat-form-field>
      <mat-label>Villkorsändrat dag</mat-label>
      <input [formControl]="form().controls.lastRenewalDate" [matDatepicker]="nextRenewal" matInput>
      <mat-datepicker-toggle
        [for]="nextRenewal"
        matIconSuffix style="margin-left: -12px;"/>
      <mat-datepicker
        #nextRenewal/>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Bindingstid</mat-label>
      <mat-select [formControl]="form().controls.binding">
        <mat-option value="3 må">3 månader</mat-option>
        <mat-option value="1 år">1 år</mat-option>
        <mat-option value="2 år">2 år</mat-option>
        <mat-option value="3 år">3 år</mat-option>
        <mat-option value="4 år">4 år</mat-option>
        <mat-option value="5 år">5 år</mat-option>
        <mat-option value="7 år">7 år</mat-option>
        <mat-option value="10 år">10 år</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Nästa villkorsändringsdag</mat-label>
      <input [formControl]="form().controls.renewalDate" [matDatepicker]="renewal" matInput>
      <mat-datepicker-toggle
        [for]="renewal"
        matIconSuffix style="margin-left: -12px;"/>
      <mat-datepicker #renewal/>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Aktuell skuld</mat-label>
      <input
        [formControl]="form().controls.currentDebt"
        matInput
        spbFormatNumber>
      <span matTextSuffix>kr</span>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Amortering</mat-label>
      <input
        [formControl]="form().controls.repaymentAmount"
        matInput
        required
        spbFormatNumber>
      <span matTextSuffix>kr</span>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Ränta</mat-label>
      <input
        [formControl]="form().controls.interest"
        class="spb-flipper"
        matInput
        required
        type="number">
      <span matTextSuffix>%</span>
    </mat-form-field>
  </form>

}
<mat-dialog-actions>
  @if (loan()) {
    <button
      (click)="send(false)"
      [disabled]="form().invalid"
      matButton="elevated">Skicka villkorsbilaga
    </button>
    <button
      (click)="send(true)"
      [disabled]="form().invalid"
      matButton="elevated">Förhandsgranska
    </button>
  }
  <button mat-dialog-close matButton="text">Avbryt</button>
</mat-dialog-actions>